module.exports = __webpack_public_path__ + "static/media/options.f29de086.png";